export default {
    path: "contact-us-enquiries",
    component: {
      render(c) {
        return c("router-view");
      },
    },
    children: [
      {
        path: "",
        name: "Lead Manager",
        meta: {
          requiresAuth: true,
        },
        component: () => import("@/views/contactUsEnquiry/contactEnquiry.vue"),
      },
    ],
  };
  